/* eslint-disable @typescript-eslint/no-explicit-any */
function getCounterersForChamp(hardCounters, countered) {
    var retArr = [];
    for (var i in hardCounters) {
        if (hardCounters[i].Champion == countered)
            retArr.push(hardCounters[i].Hard_Counters);
    }
    return retArr;
}
export { getCounterersForChamp };
